import { Box, useDisclosure } from '@televet/kibble-ui/build/chakra';
import { Menu } from '@televet/kibble-ui/build/components/Menu';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  ModalFooterButtons,
} from '@televet/kibble-ui/build/components/Modal';
import { TextInput } from '@televet/kibble-ui/build/components/TextInput';
import React, { useCallback } from 'react';

type SendTestEmailModalProps = {
  onSendTestEmail: () => void;
  testEmail: string;
  changeTestEmail: (email: string) => void;
};

const SendTestEmailModal = ({ testEmail, changeTestEmail, onSendTestEmail }: SendTestEmailModalProps): JSX.Element => {
  const { onOpen, onClose, isOpen } = useDisclosure();

  const sendTestEmail = useCallback((): void => {
    onSendTestEmail();
    onClose();
  }, [onSendTestEmail, onClose]);
  return (
    <>
      <Menu
        buttonProps={{
          variant: 'ghostNeutral',
          size: 'md',
          leftIconName: 'dotsVertical',
          showRightIcon: false,
          ml: 2,
        }}
        listProps={{
          menuItems: [
            {
              label: 'Send Test Email',
              value: 'sendTestEmail',
              onSelect: onOpen,
            },
          ],
        }}
      />

      <Modal allowEscape isOpen={isOpen} onClose={onClose} size="sm" autoFocus>
        <ModalHeader>Send Test Email</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box mt={4} mb={4}>
            <TextInput
              value={testEmail || ''}
              onChange={(e): void => changeTestEmail(e.target.value)}
              label="Email"
              placeholder="Enter email address"
            />
          </Box>
        </ModalBody>
        <ModalFooterButtons onSubmit={sendTestEmail} submitText="Send Test Email" />
      </Modal>
    </>
  );
};

export default SendTestEmailModal;
